'use strict';

/**
 * @ngdoc function
 * @name ntmApp.controller:ForecastController
 * @description
 * # ForecastController
 * Controller of the ntmApp
 */
angular.module('ntmApp')
  .controller('ForecastController', ['$scope', '$rootScope', '$timeout', 'ForecastService', '$q', '$location', 'UserInfo', 'CurrentForecast', 'StaffInfo', 'Constants', 'FlashService', 'ForecastConfirmationService',
      function ($scope, $rootScope, $timeout, ForecastService, $q, $location, UserInfo, CurrentForecast, StaffInfo, Constants, FlashService, ForecastConfirmationService) {
      
      $scope.staffDetails = true;
      $scope.header = {};
      $scope.selectedWeekChanged = {};
      $scope.newWeek = 0;
      $scope.showAnUssignedActivitiesPane = true;
      $scope.showStaffSchedule = true;
      $scope.scenarioDataChanging = false;

      $scope.Forecast = new CurrentForecast(Constants.ForecastMode.CurrentForecast);
      $scope.StaffInfo = new StaffInfo();

      $scope.setCurrentWeek = function (id) {
          $scope.weeks.forEach(function (item) {
              if (item.week === id) {
                  sessionStorage.week = id;
                  $scope.selectedWeek = item;
              }
          });
          $scope.Forecast.loadSchedulesHeaders($scope.header, $scope.selectedWeek);
          loadRightPanes($scope.header, $scope.selectedWeek);
      };

      $scope.changeForecastScope = function (scope) {

          if ($scope.header.selectedForecastScope.id !== scope.id) {
              $scope.header.selectedForecastScope = scope;
              sessionStorage.selectedForecastScopeId = scope.id;
              sessionStorage.selectedForecastScopeValue = scope.value;
              $scope.Forecast.loadSchedulesHeaders($scope.header, $scope.selectedWeek);              
              loadRightPanes($scope.header, $scope.selectedWeek);
              $scope.Forecast.loadSummary($scope.header, $scope.weeks);
          }
      };

      function initData() {

          var reloadHeader = sessionStorage.reloadHeader ? true : false;
          sessionStorage.reloadHeader = '';

          $scope.Forecast.dataLoading = true;

          ForecastService.GetForecastHeader(reloadHeader).then(function (result) {
              $scope.header = result.data;
              $scope.Forecast.initWeekSwitcher($scope);
              $scope.Forecast.RoomSchedules.UnderAllocatedStaff.setFacilityAreaViewMode($scope.header.forecastOptionsSummary.forecastView);

              if ($scope.header.openedScenarios && $scope.header.openedScenarios.length > 0) {
                  var scenarioFromSessionStorage = $scope.header.openedScenarios.firstOrDefault(function (scenario) {
                      return scenario.id === parseInt(sessionStorage.scenarioId);
                  });

                  $scope.selectedScenario = scenarioFromSessionStorage || $scope.header.openedScenarios[0];
              }

              if (result.data.forecastOptionsSummary) {
                  $scope.header.selectedForecastScope = $scope.Forecast.getSelectedForecastScope($scope.header);
                  $scope.Forecast.loadSchedulesHeaders($scope.header, $scope.selectedWeek);
                  loadRightPanes($scope.header, $scope.selectedWeek);
              }

              $scope.Forecast.dataLoading = false;

              ForecastService.GetStarScenarioButtonType().then(function (result) {

                  if (result.success) {
                      $scope.lockedScenarios = result.data.lockedScenarios;
                  }

              });

              $scope.Forecast.loadSummary($scope.header, $scope.weeks);
          });

          applyRightPanelStateFromSessionStorage();
          $scope.Forecast.setSchedulingMode($scope.showRoomSchedule ? Constants.ForecastSchedulingMode.Room : Constants.ForecastSchedulingMode.Staff);
      }

      $scope.hasLockedScenarios = function () {
          return $scope.header &&
                 $scope.header.forecastOptionsSummary &&
                !$scope.header.forecastOptionsSummary.testScenariosOnly &&
                 $scope.lockedScenarios &&
                 $scope.lockedScenarios.length > 0;
      };

      $scope.getLockedScenarioMessage = function () {
          var message = "You are locked from creating Scenarios on your current Forecast Scope until the following users either cancel or apply their Scenarios:<br/> <br/>";


          $scope.lockedScenarios.forEach(function (lockedInfo) {

              var scopes = lockedInfo.scope.map(function(scope) {
                  return scope.value;
              }).join(",");

              var messageRecord = "{0} has scenarios opened for {1}:<br/>{2}".format(lockedInfo.fullName, lockedInfo.view === 'Facility' ? 'facilities' : 'areas', scopes);
              message += messageRecord;
              message += "<br /><br />";
          });

          return message;
      };

      $scope.showStaffInfo = function () {
          showStaffInfoRightPane();
      };

      $scope.selectPersonInStaffInfoPane = function (personId) {
          showStaffInfoRightPane();
          $scope.StaffInfo.selectPersonInStaffInfoPane($scope.selectedWeek, personId, Constants.ForecastMode.CurrentForecast);
      };

      $scope.showAnUssignedActivities = function () {

          if (!$scope.showAnUssignedActivitiesPane) {
              $scope.showAnUssignedActivitiesPane = true;
              $scope.showBorrowResourcesPane = false;
              $scope.showStaffInfoPane = false;
          }

          saveRightPanelStateToSessionStorage();
      };

      function showStaffInfoRightPane() {

          if (!$scope.showStaffInfoPane) {
              $scope.showStaffInfoPane = true;
              $scope.showBorrowResourcesPane = false;
              $scope.showAnUssignedActivitiesPane = false;
              $scope.showUnderAllocatedStaffPane = false;
          }

          saveRightPanelStateToSessionStorage();
      }

      $scope.showBorrowResources = function () {

          if (!$scope.showBorrowResourcesPane) {
              $scope.showBorrowResourcesPane = true;
              $scope.showStaffInfoPane = false;
              $scope.showAnUssignedActivitiesPane = false;
			  $scope.showUnderAllocatedStaffPane = false;
          }

          saveRightPanelStateToSessionStorage();
      };

      $scope.displayStaffScheduling = function () {

          if (!$scope.showStaffSchedule) {
              $scope.showStaffSchedule = true;
			  $scope.showAnUssignedActivitiesPane = true;
              $scope.showRoomSchedule = false;
			  $scope.showStaffInfoPane = false;
			  $scope.showBorrowResourcesPane = false;

              $scope.Forecast.setSchedulingMode(Constants.ForecastSchedulingMode.Staff);
              saveRightPanelStateToSessionStorage();
              $scope.Forecast.RoomSchedules.selectedActivityType = Constants.ForecastActivityTypes.RoomActivities;
          }
      };

      $scope.displayActivitiesForSelectedType = function (type) {

          $scope.Forecast.RoomSchedules.selectedActivityType = type;
      };

      $scope.displayRoomScheduling = function () {

          if (!$scope.showRoomSchedule) {
              $scope.showStaffSchedule = false;
              $scope.showRoomSchedule = true;
              $scope.showUnderAllocatedStaffPane = true;
              $scope.showStaffInfoPane = false;
			        $scope.showBorrowResourcesPane = false;

              $scope.Forecast.setSchedulingMode(Constants.ForecastSchedulingMode.Room);
              saveRightPanelStateToSessionStorage();
          }
      };

      $scope.showUnderAllocatedStaff = function () {

          if (!$scope.showUnderAllocatedStaffPane) {
              $scope.showUnderAllocatedStaffPane = true;
              $scope.showStaffInfoPane = false;
			        $scope.showBorrowResourcesPane = false;
          }

          saveRightPanelStateToSessionStorage();
      };

      function saveRightPanelStateToSessionStorage() {
          sessionStorage.showBorrowResourcesPane = $scope.showBorrowResourcesPane;
		  sessionStorage.showUnderAllocatedStaffPane = $scope.showUnderAllocatedStaffPane;
          sessionStorage.showStaffInfoPane = $scope.showStaffInfoPane;
          sessionStorage.showAnUssignedActivitiesPane = $scope.showAnUssignedActivitiesPane;
          sessionStorage.showStaffSchedule = $scope.showStaffSchedule;
          sessionStorage.showRoomSchedule = $scope.showRoomSchedule;
      }

      function applyRightPanelStateFromSessionStorage() {
          $scope.showBorrowResourcesPane = sessionStorage.showBorrowResourcesPane === 'true';
          $scope.showStaffInfoPane = sessionStorage.showStaffInfoPane === 'true';
          $scope.showAnUssignedActivitiesPane = sessionStorage.showAnUssignedActivitiesPane === 'true';
		  $scope.showUnderAllocatedStaffPane = sessionStorage.showUnderAllocatedStaffPane === 'true';
          $scope.showRoomSchedule = sessionStorage.showRoomSchedule === 'true';
          $scope.showStaffSchedule = sessionStorage.showStaffSchedule === 'true';

          if (!$scope.showBorrowResourcesPane && !$scope.showStaffInfoPane && !$scope.showAnUssignedActivitiesPane) {
              $scope.showAnUssignedActivitiesPane = true;
          }

          if ($scope.showRoomSchedule && !$scope.showStaffInfoPane && !$scope.showBorrowResourcesPane) {
              $scope.showUnderAllocatedStaffPane = true;
          }

          if (!$scope.showRoomSchedule && !$scope.showStaffSchedule) {
              $scope.showStaffSchedule = true;
          }
      }

      $scope.startNewScenario = function () {


          var generateNewScenario = function () {

              var loading = ForecastConfirmationService.ScenarioGenerating();
              ForecastService.GenerateScenario().then(function (result) {

                  loading.dismiss();

                  if (result.success) {
                      var generatedScenarioId = result.data.scenarioId;
                      sessionStorage.scenarioId = generatedScenarioId;
                      sessionStorage.reloadHeader = true;
                      $location.path('/forecastScenario/' + generatedScenarioId);
                  }
              });
          };

          var type = $scope.header &&
                   $scope.header.forecastOptionsSummary &&
                   parseInt($scope.header.forecastOptionsSummary.forecastView) === 1 ?
                          'facilities' :
                          'areas';

          var forecastScopes = $scope.header.forecastOptionsSummary.forecastScope.map(function (scope) {
                                    return scope.value;
          }).join(", ");

          var createNewScenarioMesage = $scope.header.openedScenarios && $scope.header.openedScenarios.length  > 0 ? "Are you sure you want to Create a New Scenario?" : 
                            "Other Schedulers will be locked-out from creating their own Scenarios on a location in the following {0} determined by your Forecast Scope: <br/><br/>{1}.<br /><br />Continue?".format(type, forecastScopes);

          var createTestScenarioMessage = "Test Scenarios Only is turned on. You will not lock out other users, but your Test Scenarios can never be applied.";

          var data = {
              yes: $scope.header.forecastOptionsSummary.testScenariosOnly ? 'Okay, Create Test Scenario' : 'Yes, Create New Scenario',
              no: 'Never mind'
          };

          ForecastConfirmationService.StartNewScenario($scope.header.forecastOptionsSummary.testScenariosOnly ? createTestScenarioMessage : createNewScenarioMesage, data)
                                     .Yes(generateNewScenario)
                                     .Ask();
      };

      $scope.navigateToScenario = function (id) {
          $location.path('/forecastScenario/' + id);
      };

      function loadRightPanes(header, selectedWeek) {

          $scope.Forecast.loadRightPanes($scope.header, $scope.selectedWeek);

          var data = {
              dateFrom: selectedWeek.startDate,
              dateTo: selectedWeek.endDate,
              forecastMode: Constants.ForecastMode.CurrentForecast
          };

          ForecastService.GetStaffInfoFilter(data).then(function (result) {

              if (result.success) {
                  $scope.StaffInfo.staffContacts = result.data.staffContacts;
              }
          });
      }

      $scope.navigate = function (link) {
          $location.path(link);
      };

      UserInfo.GetUserInfo().then(function (user) {
          $scope.currentUsername = user.username;
      });

      function updateDataAccordingSocketInfo(callbackSocketData) {

          var forecastScope = $scope.header.forecastOptionsSummary.forecastScope.map(function (scope) {
              return scope.id.trim();
          });

          if ($scope.header.openedScenarios.length > 0) {
              return;
          }

          if ($scope.currentUsername !== callbackSocketData.userId) {

              var scopesIntersect = false;

              forecastScope.forEach(function (scope) {

                  callbackSocketData.scopes.forEach(function (updatedScope) {

                      if (scope === updatedScope.trim()) {
                          scopesIntersect = true;
                          $scope.scenarioDataChanging = true;

                          return;
                      }
                  });

                  if (scopesIntersect === true) {

                      return;
                  }
              });

              if (scopesIntersect === false) {

                  return;
              }

              ForecastService.GetStarScenarioButtonType().then(function (result) {

                  if (result.success) {
                      $scope.lockedScenarios = result.data.lockedScenarios;
                  }

                  $scope.scenarioDataChanging = false;
              });
          }
      }

      $scope.isLeftMenuOpened = function () {
          return $rootScope.leftMenuIsOpened;
      };



      $scope.$on('$destroy', function () {
      
      });

      $scope.Forecast.attachWatchers($scope);
      initData();

  }]);
